module.exports = __webpack_public_path__ + "img/burger.1e3013b3.svg";